import { defineMessages } from 'react-intl';

export default defineMessages({
    baseCoverages: {
        id: 'quoteandbind.ho.directives.HoOfferingSelection.defaultBaseCoverages.General Coverages',
        defaultMessage: 'General Coverages',
    },
    additionalCoverages: {
        id: 'quoteandbind.ho.directives.HoOfferingSelection.defaultAdditionalCoverages.Additional Coverages',
        defaultMessage: 'Additional Coverages',
    },

    liablityLineCoverages: {
        id: 'quoteandbind.ho.directives.HoOfferingSelection.defaultLiabilityLineCoverages.Liability Line Coverages',
        defaultMessage:'Liability Line Coverages',
    
    },
    packageSpecificCoverages: {
        id: 'quoteandbind.ho.directives.HoOfferingSelection.defaultPackageSpecificCoverages. Package-Specific Coverages',
        defaultMessage:'Package-Specific Coverages',
    },
    hoGenerateQuoteDocument: {
        id: 'quoteandbind.ho.directives.Generate Quote Document',
        defaultMessage: 'Generate Quote Document',
    },
    hoGenerateQuoteDocumentConf: {
        id: 'quoteandbind.ho.directives.Are you sure you want to generate quote document',
        defaultMessage: 'Are you sure you want to generate quote document',
    },
    hoGenerateQuoteSummary: {
        id: 'quoteandbind.common.policy-info.Generate Quote Summary',
        defaultMessage: 'Generate Quote Summary',
    },
    UpdateApplicableExtension:{
        id: 'quoteandbind.common.policy-info.Update Applicable Extension(s)',
        defaultMessage: 'Update Applicable Extension(s)',
    }

});
